<div class="container">
  @if (sent) {
    <div class="row">
      <div class="col-md-6 offset-md-3 order-sm-12 m-t-40 m-b-10">
        <p class="alert alert-success">
          Password was successfully changed. Proceed to <a [routerLink]="['/login']">log in</a>.
        </p>
      </div>
    </div>
  }
  @if (!sent) {
    <div class="row">
      <div class="col-md-6 offset-md-3 m-t-40 m-b-10">
        <alert></alert>
        <h2>Reset Your Password</h2>
        <form [formGroup]="resetForm" (ngSubmit)="reset()">
          <div class="form-group">
            <label for="password">New Password</label>
            <input type="password" class="form-control" formControlName="password"
              placeholder="Enter new password"
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
            @if (submitted && f.password.errors) {
              <div class="invalid-feedback">
                @if (f.password.errors.required) {
                  <div>Password is required</div>
                }
                @if (f.password.errors.strongPassword) {
                  <div>
                    Password does not meet complexity requirements
                  </div>
                }
              </div>
            }
            <!-- Password strength indicator -->
            <app-password-strength [password]="f.password.value" [showRequirements]="true"></app-password-strength>
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input type="password" class="form-control" formControlName="confirmPassword"
              placeholder="Confirm new password"
              [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
            @if (submitted && f.confirmPassword.errors) {
              <div class="invalid-feedback">
                @if (f.confirmPassword.errors.required) {
                  <div>Please confirm your password</div>
                }
                @if (f.confirmPassword.errors.passwordMismatch) {
                  <div>Passwords do not match</div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <button [disabled]="loading" class="btn btn-primary">
              @if (!loading) {
                <span>Change Password</span>
              }
              @if (loading) {
                <span>
                  <i class="fa fa-spinner fa-spin"></i> Changing Password...
                </span>
              }
            </button>
          </div>
          @if (error) {
            <div class="alert alert-danger">{{error}}</div>
          }
        </form>
      </div>
    </div>
  }
</div>